module.exports = __webpack_public_path__ + "static/media/video_image1.08bd4682.png";